import axios from 'axios';
import { URL } from '../../config/config';

export interface WebStartResult {
  status: string;
  statusToken?: string;
  message?: string;
}

export interface BuildStatus {
  status: 'crawling' | 'ready' | 'failed';
  website: string;
  pagesCrawled: number;
  error: string | null;
}

export const startDemoBuild = (phone: string, website: string): Promise<WebStartResult> =>
  axios
    .post(`${URL}/demo-bot/web-start`, { phone, website, funnel: 'ctwa' })
    .then((r) => r.data);

export const getBuildStatus = (token: string): Promise<BuildStatus> =>
  axios.get(`${URL}/demo-bot/web-status/${token}`).then((r) => r.data);
